module.exports = __webpack_public_path__ + "img/hand-rig-thumb.057d7c34.jpg";